export class ApiError extends Error {
  name: string;
  message: string;
  params?: Record<string, unknown>;

  constructor(name: string, message: string, params?: Record<string, unknown>) {
    super(message);
    this.name = name;
    this.message = message;
    this.params = params;
  }
}
